import {
  type BrandPageSlug,
  type LocationPageSlug,
  type CompanyPositionType,
} from '../types'

export interface SettingsTranslations {
  listings: {
    actions: Record<string, string>
    errors: Record<string, string>
    success: string
  }
  titles: Record<string, string>
  pages: {
    brand: Record<BrandPageSlug, string>
    location: Record<LocationPageSlug, string>
  }
  companyPositions: Record<CompanyPositionType, string>
  validators: Record<string, string>
}

export const settingsEn: SettingsTranslations = {
  companyPositions: {
    CEO: 'CEO',
    CFO: 'CFO',
    Director: 'Director',
    GM: 'General Manager',
    General_Counsel: 'General Counsel',
    Other: 'Other',
    VP: 'Vice President',
  },
  listings: {
    actions: {
      open: 'Open Yext',
      publish: 'Publish Menu to Yext',
      sync: 'Push listing data',
    },
    errors: {
      'get-link': 'Unable to get Yext link',
      sync: 'Unable to sync listings data',
    },
    success: 'Syncing listing data...',
  },
  pages: {
    brand: {
      'automated-marketing': 'Automated Marketing',
      'feature-toggles': 'Features',
      general: 'General',
      links: 'Links',
      notifications: 'Notifications',
      'sms-marketing': 'SMS Marketing',
      'user-notifications': 'User Notifications',
    },
    location: {
      address: 'Address',
      contact: 'Contact',
      features: 'Features',
      fees: 'Fees',
      fulfillment: 'Fulfillment',
      general: 'General',
      integrations: 'Integrations',
      links: 'Links',
      listings: 'Listings',
      notifications: 'Notifications',
    },
  },
  titles: {
    funnel: 'Funnel Settings',
    general: 'General Settings',
  },
  validators: {
    externalLink:
      'Link location must not use connected domain or ordersave.com',
  },
}
